export default __webpack_public_path__ + "static/media/background-onboarding.857d5338.jpg";